import {securityCompliancePolicy} from "../../data/securityCompliancePolicy";
import LegalAccordion from "../../components/LegalAccordion";
import "./SecurityCompliancePage.css";


const SecurityCompliancePage = () => {

    return (

        <section className="security-page">


            <div className="security-hero">

                <span>
                    Security
                </span>


                <h1>
                    Security & Compliance Policy
                </h1>


                <p>
                    Learn how Magyne protects customer data,
                    secures our platform and maintains trust
                    through responsible technology practices.
                </p>


                <div className="effective-date">

                    Effective Date: 01 July, 2026

                </div>


            </div>



            <div className="security-container">

                {
                    securityCompliancePolicy.map(section => (

                        <LegalAccordion
                            key={section.id}
                            section={section}
                        />

                    ))
                }

            </div>


        </section>

    );

};


export default SecurityCompliancePage;